// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"2441":"fc741cf57e9647f370a3","5862":"142cd48ca8ec32e57725","7874":"cd16576625b0c6e0d277"}[chunkId] + "";
};